/* Bubebaby — bb-port.js: the real-store hooks the static mock faked. bb.js stays the mock's script (+ asserted patches).
   1. the bag count bumps when Minimog's cart updates (the mock faked the bump on click)
   2. theme editor: a section re-rendered after load shows at once (reveal + stroke-draw classes)
   3. phones: product pins (hero + scene) open their card on the first tap (.is-on), the open card's tap goes to the product,
      a tap elsewhere closes it. Runs in the capture phase so bb.js's own pin toggle (desktop touch) never sees phone taps. */
(function () {
  var d = document;
  function bump() {
    d.querySelectorAll('.bb-tool__n').forEach(function (n) {
      n.classList.add('is-bump'); setTimeout(function () { n.classList.remove('is-bump'); }, 300);
    });
  }
  function subscribe() {
    var T = window.MinimogTheme, E = window.MinimogEvents;
    if (!T || !E || !T.pubSubEvents) return false;
    E.subscribe(T.pubSubEvents.cartUpdate, bump); return true;
  }
  if (!subscribe()) window.addEventListener('load', subscribe);

  d.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    s.querySelectorAll('[data-bb-draw] path').forEach(function (p) { try { p.style.setProperty('--len', Math.ceil(p.getTotalLength() + 2)); } catch (x) {} });
    s.querySelectorAll('[data-bb-reveal],[data-bb-draw]').forEach(function (el) { el.classList.add('is-in'); });
  });

  var phone = window.matchMedia('(max-width:767px)');
  d.addEventListener('click', function (e) {
    if (!phone.matches) return;
    var pin = e.target.closest && e.target.closest('.bb-hero .bb-pin, .bb-scene .bb-pin');
    var open = d.querySelectorAll('.bb-pin.is-on');
    if (!pin) { open.forEach(function (o) { o.classList.remove('is-on'); }); return; }
    e.stopPropagation();
    if (pin.classList.contains('is-on') && e.target.closest('.bb-pin__card')) return;
    e.preventDefault();
    var on = !pin.classList.contains('is-on');
    open.forEach(function (o) { o.classList.remove('is-on'); });
    pin.classList.toggle('is-on', on);
  }, true);
})();
